// @ts-nocheck
import * as React from "react";
import { Ic, PasswordInput, apiErrorMessage, siteName, brandParts } from "./common";

// Password reset — 사용자 self-reset의 토큰 소비 단계.
// /password-reset?token=xxx 진입 → 새 비번 입력 → PATCH /api/v1/password_resets/:token
// 결과: 200 → /login으로 이동, 404 → "만료/잘못된 링크" 안내, 422 → 비번 정책 위반 사유.

function PasswordReset() {
  // 토큰은 URL query에서. 마운트 후 한 번만 읽으면 충분.
  const token = React.useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("token") || "";
  }, []);

  const [pw, setPw]       = React.useState("");
  const [pw2, setPw2]     = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const [err, setErr]     = React.useState(null);
  const [phase, setPhase] = React.useState(token ? "input" : "missing"); // missing | input | done

  const submit = async (e) => {
    if (e) e.preventDefault();
    setErr(null);
    if (pw !== pw2) { setErr("새 비밀번호가 일치하지 않습니다."); return; }
    if (pw.length < 6) { setErr("비밀번호는 최소 6자 이상이어야 합니다."); return; }
    setSubmitting(true);
    try {
      const r = await fetch(`/api/v1/password_resets/${encodeURIComponent(token)}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ password: pw }),
      });
      if (r.status === 404) {
        const j = await r.json().catch(() => ({}));
        setErr(j.message || "재설정 링크가 만료되었거나 잘못되었습니다. 다시 요청해주세요.");
        return;
      }
      if (!r.ok) {
        const j = await r.json().catch(() => ({}));
        setErr(apiErrorMessage(j, r.status));
        return;
      }
      setPhase("done");
    } catch (e) { setErr(apiErrorMessage(e)); } finally { setSubmitting(false); }
  };

  return (
    <div className="app" style={{display:'grid', gridTemplateColumns:'1fr 1fr', height:'100%', background:'var(--bg)'}}>
      <div style={{padding:'48px 56px', background:'linear-gradient(160deg, #2A241F 0%, #3F342C 60%, #5A4434 100%)', color:'#F5EBD8', position:'relative', overflow:'hidden', display:'flex', flexDirection:'column'}}>
        <a href="/" style={{display:'flex', alignItems:'center', gap:10, color:'inherit', textDecoration:'none'}}>
          <div className="brand-mark" style={{width:32, height:32}}>{brandParts(siteName()).mark}</div>
          <div>
            <div style={{fontWeight:800, fontSize:15, color:'#fff'}}>{brandParts(siteName()).name}</div>
            {brandParts(siteName()).sub && <div style={{fontSize:10, color:'#A89A7C', letterSpacing:'0.06em'}}>{brandParts(siteName()).sub}</div>}
          </div>
        </a>

        <div style={{marginTop:60}}>
          <div style={{fontSize:11, color:'var(--orange-300)', fontWeight:700, letterSpacing:'0.08em', marginBottom:14}}>새 비밀번호 설정</div>
          <h1 style={{fontSize:36, fontWeight:800, lineHeight:1.25, letterSpacing:'-0.02em', margin:0, color:'#fff'}}>
            안전한 비밀번호로<br/>다시 시작해주세요.
          </h1>
          <p style={{fontSize:14, lineHeight:1.7, color:'#D4C9B2', marginTop:18, maxWidth:380}}>
            최소 6자, 영문과 숫자를 모두 포함해야 합니다. 이전에 사용하지 않은 비밀번호를 권장합니다.
          </p>
        </div>
      </div>

      <form onSubmit={submit} style={{padding:'48px 56px', display:'flex', flexDirection:'column', overflow:'auto'}}>
        <div style={{display:'flex', justifyContent:'flex-end', fontSize:12, color:'var(--ink-3)'}}>
          기억나셨나요? <a href="/login" style={{color:'var(--orange-600)', fontWeight:700, marginLeft:6, textDecoration:'none'}}>로그인으로 돌아가기 →</a>
        </div>

        {phase === "missing" && (
          <div style={{margin:'52px 0 28px'}}>
            <h2 style={{fontSize:28, fontWeight:800, letterSpacing:'-0.02em', margin:0}}>유효하지 않은 링크</h2>
            <p style={{color:'var(--ink-3)', fontSize:13, marginTop:8, lineHeight:1.7}}>
              재설정 토큰이 URL에 없습니다.
              <br/><a href="/forgot-password" style={{color:'var(--orange-600)', fontWeight:700}}>비밀번호 찾기에서 다시 요청해주세요.</a>
            </p>
          </div>
        )}

        {phase === "input" && (
          <>
            <div style={{margin:'52px 0 28px'}}>
              <h2 style={{fontSize:28, fontWeight:800, letterSpacing:'-0.02em', margin:0}}>새 비밀번호 설정</h2>
              <p style={{color:'var(--ink-3)', fontSize:13, marginTop:8}}>새 비밀번호를 입력하고 확인해주세요.</p>
            </div>

            {err && <div style={{padding:'10px 14px', background:'var(--rose-50)', color:'var(--rose-500)', borderRadius:10, fontSize:12.5, marginBottom:14}}>{err}</div>}

            <div className="label">새 비밀번호</div>
            <PasswordInput autoComplete="new-password" required minLength={6}
              value={pw} onChange={e=>setPw(e.target.value)} placeholder="최소 6자, 영문+숫자" style={{marginBottom:14}}/>

            <div className="label">새 비밀번호 확인</div>
            <PasswordInput autoComplete="new-password" required minLength={6}
              value={pw2} onChange={e=>setPw2(e.target.value)} placeholder="다시 한 번 입력" style={{marginBottom:14}}/>

            <button type="submit" disabled={submitting || !pw || !pw2} className="btn btn-primary btn-lg" style={{marginTop:8, width:'100%'}}>
              {submitting ? '설정 중…' : '비밀번호 변경 →'}
            </button>
          </>
        )}

        {phase === "done" && (
          <div style={{margin:'52px 0 28px'}}>
            <div style={{width:48, height:48, borderRadius:12, background:'var(--green-50)', color:'var(--green-600)', display:'grid', placeItems:'center', marginBottom:18}}>
              <span style={{width:24, height:24, display:'inline-block'}}>{Ic.check}</span>
            </div>
            <h2 style={{fontSize:28, fontWeight:800, letterSpacing:'-0.02em', margin:0}}>비밀번호가 변경되었습니다</h2>
            <p style={{color:'var(--ink-3)', fontSize:13, marginTop:8, lineHeight:1.7}}>
              새 비밀번호로 다시 로그인해주세요.
            </p>
            <a href="/login" className="btn btn-primary btn-lg" style={{marginTop:24, textDecoration:'none', display:'flex', justifyContent:'center'}}>로그인 화면으로 →</a>
          </div>
        )}
      </form>
    </div>
  );
}

export { PasswordReset };
